import { typesense } from '../clients/typesense';
import { SearchResponseHit } from 'typesense/lib/Typesense/Documents';

// typesense
export const searchBrands = async (query: string) =>
  typesense
    .collections('Brands')
    .documents()
    .search({
      q: query,
      query_by: 'data.name',
      sort_by: 'data.name:asc',
      limit: 10,
    })
    .then((result) =>
      result.hits?.map(({ document }: SearchResponseHit<any>) => document.data)
    );
